import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {deleteProduct, hideDeleteProductModal} from "./actions";
import DeleteFormModal from "../common/DeleteFormModal";

const DeleteProductModal = ({
                              onDelete,
                              product,
                              productDeleting,
                              hideDeleteProductModal,
                              deleteProduct,
                              visible
                            }) => {
  const productHandle = {productId: product.productId};
  return (
    <DeleteFormModal entityType="Product" entityName={product.display} entityHandle={productHandle} visible={visible}
                     entityDeleting={productDeleting} deleteEntity={deleteProduct}
                     hideDeleteFormModal={hideDeleteProductModal} onDelete={onDelete} includeHistoryMessage={true}/>);
};

DeleteProductModal.propTypes = {
  onDelete: PropTypes.func.isRequired,
  /* state */
  visible: PropTypes.bool.isRequired,
  product: PropTypes.object,
  productDeleting: PropTypes.bool.isRequired,
  /* actions */
  hideDeleteProductModal: PropTypes.func.isRequired,
  deleteProduct: PropTypes.func.isRequired,
};

// const DeleteProductFormModal = Form.create({})(DeleteProductModal);

const mapStateToProps = state => ({
  visible: state.product.deleteProductModalVisible,
  product: state.product.productToDelete,
  productDeleting: state.product.productDeleting,
});

const mapDispatchToProps = dispatch => ({
  hideDeleteProductModal: bindActionCreators(hideDeleteProductModal, dispatch),
  deleteProduct: bindActionCreators(deleteProduct, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteProductModal);



// WEBPACK FOOTER //
// ./src/Product/DeleteProductFormModal.js